// extracted by mini-css-extract-plugin
export default {"styles":"LoadingDialog_styles__QlzVe"};